import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from './cn';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  compact?: boolean;
  inverted?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ compact = false, inverted = false, className, children, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(
        'rounded-card-lg shadow-card border',
        inverted
          ? 'bg-ink text-paper border-ink-2'
          : 'bg-white text-ink border-line',
        compact ? 'p-3' : 'p-5',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  ),
);
Card.displayName = 'Card';
